import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { styleForBreakpoints } from '../../../helpers/media-style';
export var InfoWithIconsWrapper = styled.span(_templateObject(), function (_ref) {
  var $vertical = _ref.$vertical,
      $fullWidth = _ref.$fullWidth;
  return $vertical === false ? $fullWidth ? "\n          flex-direction: row;\n          justify-content: space-between;\n        " : "\n          flex-direction: row;\n          justify-content: flex-start;\n        " : styleForBreakpoints($vertical, function ($vertical) {
    return $vertical ? "\n              flex-direction: column;\n              justify-content: flex-start;\n            " : $fullWidth ? "\n              flex-direction: row;\n              justify-content: space-between;\n            " : "\n              flex-direction: row;\n              justify-content: flex-start;\n            ";
  });
}, function (_ref2) {
  var $fullWidth = _ref2.$fullWidth;
  return $fullWidth ? "width: 100%;" : '';
});